import * as React from 'react';
import { About } from './About';
import { WithGroup, WithGroupProps } from '../Context';
import { compose } from '@wix/social-groups-common/dist/src/compose';
import { GroupInfo } from './GroupInfo';
import { GroupRules } from './GroupRules';
import { GroupActivity } from './GroupActivity';
import {
  withTpaComponentsConfig,
  WithTpaComponentsConfigProps,
} from '../Context/withTpaComponentsConfig';

import styles from './AboutPage.st.css';

export const AboutPageComponent: React.FunctionComponent<WithGroupProps &
  WithTpaComponentsConfigProps> = props => {
  const { group, updateProgress, mobile, rules = [] } = props;

  /**
   * Changed to flex layout, 🤔
   * because when grid is used => RCE can took place of column-gap too
   */
  const renderDesktop = () => (
    <div {...styles('root')}>
      <div className={styles.bigColumn}>
        <GroupActivity group={group} />
        <About group={group} updateProgress={updateProgress} />
        <GroupRules rules={rules} />
      </div>
      <div className={styles.gap}></div>
      <div className={styles.smallColumn}>
        <GroupInfo group={group} />
      </div>
    </div>
  );

  const renderMobile = () => (
    <div>
      <About group={group} updateProgress={updateProgress} />
      <GroupInfo group={group} />
      <GroupActivity group={group} />
      <GroupRules rules={rules} />
    </div>
  );

  return mobile ? renderMobile() : renderDesktop();
};

const enhance = compose(WithGroup, withTpaComponentsConfig);

export const AboutPage = enhance(AboutPageComponent);
